import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {
  Autocomplete, Checkbox, FormControlLabel, FormGroup, Typography,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Clear, Description } from "@mui/icons-material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getFormMode } from "../../../../lib/helpers";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import UnLock from "../../../../GlobalFunction/UnLock";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import {
  getTicketSeveritydrp,
  getTicketTagdrp,
  getTicketTypedrp,
  getTktCategorydrp,
  getWardenDrp,
  insertTicket,
  retriveTicket,
  updateTicket,
} from "../../../../Api/ServiceMst/Api";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import { z } from "zod";
import axiosInstance from "../../../../lib/axios";
import CustomAutoCompleteNew from "../../../AutoComplete/CustomAutoCompleteNew";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from 'react-to-print';

const FORM_MODE = getFormMode();
const FORM_INIT_STATE = {
  TktServiceName: "",
  TktCategoryId: "",
  TktSubCategoryId: "",
  TicketTypeId: "",
  TicketTagId: "",
  TicketSeverityId: "",
  LeadTime: "0",
  Remark: "",
  Description: "",
  Status: "1",
};

const serviceFormSchema = z.object({
  TktCategoryId: z.number().min(1, "Category is required"),
  TktSubCategoryId: z.number().min(1, "SubCategory is required"),
  TktServiceName: z.string().min(1, "Mobile is required"),
  TicketTypeId: z.number().min(1, "type is required"),
  TicketTagId: z.number().min(1, "Tag is required"),
  TicketSeverityId: z.number().min(1, "Severity is required"),
  LeadTime: z.string().optional(),
  Description: z.string().optional(),
  Remark: z.string().optional(),
  Status: z.enum(["0", "1"]).optional()
});

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 40 },
  { id: "TktServiceName", label: "ServiceName", minWidth: 100 },
  { id: "TktCategoryName", label: "Category", minWidth: 100 },
  { id: "TktSubCategoryName", label: "SubCategory", minWidth: 100 },
  { id: "TicketTypeName", label: "Type", minWidth: 60 },
  { id: "TicketServName", label: "Priority", minWidth: 60 },
  { id: "TicketTagName", label: "Tag", minWidth: 50 },
  { id: "Status", label: "Status", minWidth: 50 },
];

const Ticket = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState(FORM_INIT_STATE);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [type, setType] = useState([]);
  const [tag, setTag] = useState([]);
  const [severity, setSeverity] = useState([]);
  const [UserId] = sessionStorage.getItem("UserId");
  const [Status, setStatus] = useState("1");
  const [isRefCategory, setIsRefCategory] = useState(false);
  const [isRefSubCategory, setIsRefSubCategory] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const openCategory = () => {
    window.open("/ticket-category")
  };

  const openSubCategory = () => {
    window.open("/ticket-subcategory")
  };

  const handleRefreshCategory = async () => {
    setIsRefCategory(true);
    try {
      const response = await getTktCategorydrp();
      if (response && response.data) {
        const { Status, Data } = response.data;
        if (Status === 0 && Array.isArray(Data)) {
          setCategories(Data);

        } else {
          setCategories([]);
        }
      }
    } catch (error) {
      console.error("Error fetching categories:", error);

    } finally {
      setTimeout(() => {
        setIsRefCategory(false);
      }, 300);
    }
  };

  const handleRefSubCategory = async () => {
    if (form.TktCategoryId) {
      setIsRefSubCategory(true);
      try {
        const response = await axiosInstance.post("/TktSubCategory/getTktSubCategorydrp", {
          flag: "",
          TktCategoryId: form.TktCategoryId,
        });
        const { data: { Status, Data } } = response;

        if (Status === 0 && Array.isArray(Data)) {
          setSubCategories(Data);
        } else {
          setSubCategories([]);
        }
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      } finally {
        setTimeout(() => {
          setIsRefSubCategory(false);
        }, 300);
      }
    }
  };

  const { TicketTagId, TicketTypeId, TicketSeverityId, } = location.state || {};

  const [error, setError] = useState({
    roomId: false,
    roombedName: false,
    remark: false,
  });

  const [currentTktServiceId, setCurrentTktServiceId] = useState(() => {
    return location?.state?.TktServiceId;
  });

  const [mode, setMode] = useState(() =>
    currentTktServiceId ? FORM_MODE.read : FORM_MODE.add
  );

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const roombedNameRef = useRef(null);
  const remarkRef = useRef(null);

  const handleChangeStatus = (event) => {
    const newStatus = event.target.checked ? "1" : "0";

    setStatus(newStatus);
    setForm(prev => ({
      ...prev,
      Status: newStatus
    }));
  };

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await getTktCategorydrp();
      if (response && response.data) {
        const { Status, Data } = response.data;
        if (Status === 0 && Array.isArray(Data)) {
          setCategories(Data);
        } else {
          setCategories([]);
        }
      }
    };
    fetchCategories();
  }, []);

  //subcategory drp
  useEffect(() => {
    const getTktSubCategorydrp = async () => {
      if (form.TktCategoryId) {
        try {
          const response = await axiosInstance.post("/TktSubCategory/getTktSubCategorydrp", {
            flag: "",
            TktCategoryId: form.TktCategoryId,
          });
          const { data: { Status, Data }, } = response;

          if (Status === 0 && Array.isArray(Data)) {
            setSubCategories(Data);

            if (Data.length > 0) {
              const validSubCategory = Data.find(sub => sub.Id === form.TktSubCategoryId);
              if (!validSubCategory) {
                setForm(prevState => ({ ...prevState, TktSubCategoryId: "" }));
              }
            } else {
              setForm(prevState => ({ ...prevState, TktSubCategoryId: "" }));
            }
          } else {
            setSubCategories([]);
          }
        } catch (error) {
          console.error(error, "Error: subcategory could not be fetched");
        }
      }
    };
    getTktSubCategorydrp();

  }, [form.TktCategoryId]);

  useEffect(() => {
    (async () => {
      const [res3, res4, res5] = await Promise.all([
        getTicketTypedrp(),
        getTicketTagdrp(),
        getTicketSeveritydrp(),
      ]);
      if (res3 instanceof Error) {
        return console.error(res3.message);
      } else {
        const { data: { Status, responseStatusCode, Data }, } = res3;
        if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
          setType(Data);
          if (mode === FORM_MODE.add && TicketTypeId) {

          }
        }
      }

      if (res4 instanceof Error) {
        return console.error(res4.message);
      } else {
        const { data: { Status, responseStatusCode, Data }, } = res4;
        if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
          setTag(Data);

          if (mode === FORM_MODE.add && TicketTagId) {

          }
        }
      }

      if (res5 instanceof Error) {
      } else {
        const { data: { Status, responseStatusCode, Data }, } = res5;
        if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
          setSeverity(Data);
          if (mode === FORM_MODE.add && TicketSeverityId) {
          }
        }
      }
    })();
  }, [TicketTagId, TicketTypeId, TicketSeverityId]);

  //For Retrive
  useEffect(() => {
    if (currentTktServiceId) {
      fetchTicketData();
    }
  }, []);

  const handlePrevious = async () => {
    if (!currentTktServiceId && currentTktServiceId < 1) return;
    await fetchTicketData("P");
  };

  const handleNext = async () => {
    if (!currentTktServiceId) return;
    await fetchTicketData("N");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    const parsedValue = ["TktCategoryId", "TktSubCategoryId", "TicketTypeId", "TicketTagId", "TicketSeverityId"].includes(name)
      ? parseInt(value, 10) || 0
      : value;
    setForm((prevState) => ({
      ...prevState,
      [name]: parsedValue,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === roombedNameRef.current) {
        remarkRef.current.focus();
      } else {
        roombedNameRef.current.focus();
      }
    }
  };

  const handleEdit = async () => {
    setMode(FORM_MODE.edit);
  };

  const handleAdd = () => {
    setIsAdding(true);
    setMode(FORM_MODE.add);
    setForm(FORM_INIT_STATE);
  };

  useEffect(() => {
    if (isAdding) return;
  }, [form.TktCategoryId, isAdding]);

  useEffect(() => {
    if (isAdding) {
      setIsAdding(false);
    }
  }, [form]);

  const handleCancel = async () => {
    if (mode === FORM_MODE.add) {
      const response = await retriveTicket({
        TktServiceId: 1,
        Flag: "L",
      });

      const { data: { Status, responseStatusCode, Data, Message }, } = response;
      if (Status === 0 && responseStatusCode === 1) {
        setForm({
          TktServiceName: Data[0]?.TktServiceName,
          TktCategoryId: Data[0]?.TktCategoryId,
          TktSubCategoryId: Data[0]?.TktSubCategoryId,
          TicketTypeId: Data[0]?.TicketTypeId,
          TicketTagId: Data[0]?.TicketTagId,
          TicketSeverityId: Data[0]?.TicketSeverityId,
          // WardenId: Data[0]?.WardenId,
          // EscalateId: Data[0].EscalateId,
          // ServiceProvId: Data[0].ServiceProvId,
          LeadTime: Data[0].LeadTime,
          Remark: Data[0]?.Remark,
          Description: Data[0]?.Description,
        });
        setMode(FORM_MODE.read);
        setCurrentTktServiceId(Data[0]?.TktServiceId);
      }
    } else {
      await UnLock(currentTktServiceId, "MstTicket", "TktServiceId");
      await fetchTicketData("R");
    }
  };

  const handleExit = () => {
    navigate(`/service-table`);
  };

  const handleDelete = async () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      const response = await retriveTicket({
        TktServiceId: currentTktServiceId,
        Flag: "D",
      });
      if (response instanceof Error) {
        return console.error("Error: could not delete room");
      }
      const { data: { Status, Message, Data }, } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 1000 });
        } else {
          toast.error(Message, { autoClose: 1000 });
        }
      }
      await fetchTicketData("N");
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTicketData = async (flag = "R", TktServiceId) => {
    const response = await retriveTicket({
      TktServiceId: TktServiceId || currentTktServiceId,
      Flag: flag,
    });

    if (response instanceof Error) {
      console.log(response.message);
      return;
    }

    const { data: { Status: apiStatus, responseStatusCode, Data, Message } } = response;

    if (apiStatus === 0 && responseStatusCode === 1 && Array.isArray(Data) && Data.length > 0) {
      const record = Data[0];

      setForm({
        TktServiceName: record.TktServiceName || "",
        TktCategoryId: record.TktCategoryId || "",
        TktSubCategoryId: record.TktSubCategoryId || "",
        TicketTypeId: record.TicketTypeId || "",
        TicketTagId: record.TicketTagId || "",
        TicketSeverityId: record.TicketSeverityId || "",
        LeadTime: record.LeadTime || "0",
        Description: record.Description || "",
        Remark: record.Remark || "",
        Status: record.Status?.toString() || "0",     // ←←← THIS WAS MISSING
      });

      setStatus(record.Status?.toString() || "0");   // Keep this for checkbox
      setMode(FORM_MODE.read);
      setCurrentTktServiceId(record.TktServiceId);
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: "",
      };
      try {
        const res = await axiosInstance.post('Ticket/getTicketDashBoard', { params });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  const handleSubmit = async () => {
    const result = serviceFormSchema.safeParse(form);

    if (!result.success) {
      return toast.info("Please fill in all required inputs correctly.", {
        autoClose: 1000,
      });
    }
    const { data } = result;
    const payload = {
      TktServiceName: data.TktServiceName,
      TktCategoryId: data.TktCategoryId,
      TktSubCategoryId: data.TktSubCategoryId,
      TicketTypeId: data.TicketTypeId,
      TicketTagId: data.TicketTagId,
      WardenId: 1,
      EscalateId: 1,
      ServiceProvId: 1,
      LeadTime: data.LeadTime || 0,
      TicketSeverityId: data.TicketSeverityId,
      Description: data.Description,
      Status: data.Status,
      Remark: data.Remark,
    };

    let response;
    if (mode === FORM_MODE.edit && currentTktServiceId) {
      payload.TktServiceId = currentTktServiceId;
      payload.UpdatedBy = parseInt(UserId);
      await UnLock(currentTktServiceId, "MstTicket", "TktServiceId");
      response = await updateTicket(payload);
    } else {
      payload.CreatedBy = parseInt(UserId);
      response = await insertTicket(payload);
    }
    const { data: { Status, Message }, } = response;
    if (Status === 0 && Message) {
      setMode(FORM_MODE.read);
      toast.success(Message, {
        autoClose: 1000,
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <Box className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
        }}>
        <Grid container spacing={2} sx={{
          width: { xs: "93%", sm: "80%", md: "80%" },
          height: { xs: "810px", sm: "auto", md: 'auto' },
          margin: 'auto',
          marginTop: { xs: "60px", sm: 0, md: 'auto' },
          marginBottom: { xs: "110px", sm: 0, md: 'auto' },
          borderRadius: '8px',
          padding: { xs: '0px 5px 5px 5px', sm: '0px 20px 20px 20px' },
          backgroundColor: '#fff',
        }}   >
          <Grid item xs={12} className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: "block",
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== FORM_MODE.read ||
                  !currentTktServiceId ||
                  currentTktServiceId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: "block",
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== FORM_MODE.read}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Service Request
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Service/Complaint Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} md={12} className="form_field"
            sx={{
              marginInline: { xs: "10px", sm: "80px", md: '60px' },
              marginBlock: { xs: "2px", sm: "20px", md: '20px' }
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6} lg={6}>
                    <CustomAutoCompleteNew
                      id="category-select"
                      name="TktCategoryId"
                      options={categories}
                      value={categories.find((category) => category.Id === form.TktCategoryId) || ''}
                      onChange={handleInputChange}
                      label={<span>Category <span style={{ color: "red" }}>*</span></span>}
                      disabled={mode === FORM_MODE.read}
                      onAddClick={openCategory}
                      onRefreshClick={handleRefreshCategory}
                      isRefreshing={isRefCategory}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <CustomAutoCompleteNew
                      id="subcategory-select"
                      name="TktSubCategoryId"
                      options={subCategories}
                      value={subCategories.find((subcategory) => subcategory.Id === form.TktSubCategoryId) || ''}
                      onChange={handleInputChange}
                      label={<span> SubCategory <span style={{ color: "red" }}>*</span></span>}
                      disabled={mode === FORM_MODE.read}
                      onAddClick={openSubCategory}
                      onRefreshClick={handleRefSubCategory}
                      isRefreshing={isRefSubCategory}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* row 2 */}
              <Grid item xs={12} md={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12}>
                    <TextField
                      id="ticketservicename"
                      name="TktServiceName"
                      label={
                        <span>
                          Service Name<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.TktServiceName}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      error={error.remark}
                      helperText={error.remark && ""}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/* row 3 */}
              <Grid item xs={12} md={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="tickettypename-select"
                      name="TicketTypeId"
                      options={type}
                      value={type.find((tkttype) => tkttype.Id === form.TicketTypeId) || ''}

                      onChange={handleInputChange}
                      label={
                        <span>
                          Type <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="tickettagname-select"
                      name="TicketTagId"
                      options={tag}
                      value={tag.find((tkttag) => tkttag.Id === form.TicketTagId) || ''}
                      onChange={handleInputChange}
                      label={
                        <span>
                          Tag <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="leadTimeHour"
                      name="LeadTime"
                      label="Lead Time (Hour)"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.LeadTime}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      error={error.LeadTime}
                      helperText={error.remark && ""}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      id="leadTimeMinutes"
                      name="LeadTime"
                      label="Lead Time (Minutes)"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.LeadTime ? (parseFloat(form.LeadTime) * 60).toFixed(2) : ""}
                      onChange={(e) => {
                        const minutes = e.target.value;
                        const hours = minutes === "" ? "" : (parseFloat(minutes) / 60).toFixed(2);
                        setForm((prev) => ({ ...prev, LeadTime: hours }));
                      }}
                      disabled={mode === FORM_MODE.read}
                      error={error.LeadTime}
                      helperText={error.remark && ""}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="ticketseverityname-select"
                      name="TicketSeverityId"
                      options={severity}
                      value={severity.find((tktseverity) => tktseverity.Id === form.TicketSeverityId) || ''}
                      onChange={handleInputChange}
                      label={
                        <span>
                          Severity <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>

                  <Grid item xs={12} md={8}>
                    <TextField
                      id="remark"
                      name="Remark"
                      label="Remark"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.Remark}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                      error={error.remark}
                      helperText={error.remark && ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={mode === FORM_MODE.read}
                            checked={Status === "1"}
                            onChange={handleChangeStatus}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>

                  {/* Row 4 - Description */}
                  <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        {/* <Typography variant="subtitle1" gutterBottom>
                          Service Description
                        </Typography>
                        <ReactQuill
                          theme="snow"
                          value={form.Description}
                          disabled={mode === FORM_MODE.read}
                          onChange={(value) =>
                            setForm((prevForm) => ({
                              ...prevForm,
                              Description: value,
                            }))
                          }
                          style={{
                            height: "150px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            paddingBottom: "30px",
                          }}
                        /> */}
                        <TextField
                          fullWidth
                          label="Service Description"
                          name="Description"
                          value={form.Description}
                          disabled={mode === FORM_MODE.read}
                          onChange={handleInputChange}
                          multiline
                          rows={1}
                          variant="filled"
                          className="custom-textfield"
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "70px",
                            },
                            "& .MuiInputBase-input": {
                              resize: "vertical",
                            },
                            "& .MuiFilledInput-root": {
                              "&:hover": {
                                backgroundColor: "transparent",
                              },
                              "&.Mui-focused": {
                                backgroundColor: "transparent",
                              },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button"
            style={{
              marginBottom: {
                xs: '10px ',
                sm: '0px',
                md: '0px',
                lg: '0px',
              }
            }}
          >
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)"
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)"
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Service Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: '#f5f5f5' }}
          />
        )}
      </div>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button size="small"
            sx={{
              backgroundColor: "#dd3d3d",
              color: "white",
              "&:hover": {
                backgroundColor: "#dd3d3d",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button size="small"
            sx={{
              backgroundColor: "#329948",
              color: "white",
              "&:hover": {
                backgroundColor: "#329948",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Ticket;
